// Definir el tipo para los colores
interface StoreColorTheme {
  PRIMARY_MAIN: string
  PRIMARY_CONTRAST: string
  SECONDARY_MAIN: string
  BACKGROUND: string
}

// Definir los temas de colores
const STORE_COLOR_THEMES: Record<string, StoreColorTheme> = {
  tea: {
    PRIMARY_MAIN: '#27352E',
    PRIMARY_CONTRAST: '#27352E',
    SECONDARY_MAIN: '#27352e',
    BACKGROUND: '#FFEDE0',
  },
  ge: {
    PRIMARY_MAIN: '#E78923',
    PRIMARY_CONTRAST: '#275E56',
    SECONDARY_MAIN: '#27352e',
    BACKGROUND: '#F5F6F8',
  },
  'le-pain-quotidien': {
    PRIMARY_MAIN: '#FDC400',
    PRIMARY_CONTRAST: '#000000',
    SECONDARY_MAIN: '#4E342E',
    BACKGROUND: '#FBF5EE',
  },
  cs: {
    PRIMARY_MAIN: '#848624',
    PRIMARY_CONTRAST: '#18231d',
    SECONDARY_MAIN: '#18231d',
    BACKGROUND: '#EAEAE2',
  },
  paru: {
    PRIMARY_MAIN: '#15182D',
    PRIMARY_CONTRAST: '#15182D',
    SECONDARY_MAIN: '#030B21',
    BACKGROUND: '#EDEDEF',
  },
  jb: {
    PRIMARY_MAIN: '#080808',
    PRIMARY_CONTRAST: '#18231d',
    SECONDARY_MAIN: '#ebebe1',
    BACKGROUND: '#ebebe1',
  },
  ts: {
    PRIMARY_MAIN: '#50c9b5',
    PRIMARY_CONTRAST: '#ffffff',
    SECONDARY_MAIN: '#b68356',
    BACKGROUND: '#b68356',
  },
  ronnie: {
    PRIMARY_MAIN: '#FCBF00',
    PRIMARY_CONTRAST: '#000000',
    SECONDARY_MAIN: '#000000',
    BACKGROUND: '#FBFBFB',
  },
  cm: {
    PRIMARY_MAIN: '#010101',
    PRIMARY_CONTRAST: '#010101',
    SECONDARY_MAIN: '#010101',
    BACKGROUND: '#E0E0E0',
  },
  vicolo: {
    PRIMARY_MAIN: '#919145',
    PRIMARY_CONTRAST: '#ffffff',
    SECONDARY_MAIN: '#010101',
    BACKGROUND: '#EFE4CE',
  },
  'signora-mariola': {
    PRIMARY_MAIN: '#1D1D1B',
    PRIMARY_CONTRAST: '#986E4C',
    SECONDARY_MAIN: '#1D1D1B',
    BACKGROUND: '#EFE4CE',
  },
  'acai-brasil': {
    PRIMARY_MAIN: '#5B1A34',
    PRIMARY_CONTRAST: '#27352E',
    SECONDARY_MAIN: '#27352E',
    BACKGROUND: '#F8F4EB',
  },
  'la-condesa': {
    PRIMARY_MAIN: '#1B5B75',
    PRIMARY_CONTRAST: '#27352E',
    SECONDARY_MAIN: '#F7EEDD',
    BACKGROUND: '#F7EEDD',
  },
  'el-diez': {
    PRIMARY_MAIN: '#1B5B75',
    PRIMARY_CONTRAST: '#27352E',
    SECONDARY_MAIN: '#27352E',
    BACKGROUND: '#F8F4EB',
  },
}

// Definir un tema por defecto (para evitar valores `undefined`)
const DEFAULT_STORE_THEME: StoreColorTheme = STORE_COLOR_THEMES.ge

// Obtener el tema según la aplicación o usar el tema por defecto
const STORE_COLORS: StoreColorTheme =
  STORE_COLOR_THEMES[process.env.REACT_APP_NAME?.toLowerCase() || 'ge'] || DEFAULT_STORE_THEME

export { STORE_COLORS }
